import locales from './locales'

const getBottomInfo = (lang: 'en' | 'pt' | 'es' = 'pt') => [
	{
		key: 1,
		title: locales[lang]['TERMS_POLICIES'],
		link: 'https://termos-e-politicas.sympla.com.br/hc/pt-br',
	},
	{
		key: 2,
		title: locales[lang]['CODE_CONDUCT'],
		link: 'https://www.sympla.com.br/codigo-de-etica-e-conduta',
	},
	{
		key: 3,
		title: locales[lang]['SITE_MAP'],
		link: 'https://www.sympla.com.br/sitemap.xml',
	},
]

export default getBottomInfo
